module.exports = __webpack_public_path__ + "img/sound.adb3aafa.svg";